if (!customElements.get('location-selector')) {
  customElements.define(
    'location-selector',
    class LocationSelector extends ModalDialog {
      constructor() {
        super();
        this.shopUrl = window.shopUrl;
        this.shopLocation = window.shopLocation;
        this.form = this.querySelector('form');
        this.countries = this.querySelector('#countries');
        this.eventListeners = [];
      }

      async connectedCallback() {
        if (!Shopify.designMode) {
          await this.initLocationSelector();
        }
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }

      countryList() {
        try {
          const countries = this.countries.textContent.trim();
          const parsedData = JSON.parse(countries);

          if (parsedData && parsedData.countries && Array.isArray(parsedData.countries)) {
            return parsedData.countries;
          }

          console.error('Invalid countries data structure:', parsedData);
          return [];
        } catch (error) {
          console.error('Error parsing countries JSON:', error, this.countries.textContent);
          return [];
        }
      }

      async initLocationSelector() {
        const selectedLocation = this.getLocationCookie('country');
        const urlParams = new URLSearchParams(window.location.search);

        if (!selectedLocation || selectedLocation !== this.shopLocation) {
          if (urlParams.get('country') || this.getLocationCookie('country_override')) return;

          const userLocation = await this.getUserLocation();
          if (!userLocation) return;

          if (userLocation.handle !== this.shopLocation) {
            this.show();
          }

          this.setupSuggestedCountry(userLocation.name);
          this.setupModalCloseButton();
          this.attachFormChangeListener(userLocation);
        }
      }

      async getUserLocation() {
        const url = `${this.shopUrl}/browsing_context_suggestions.json`;

        try {
          const response = await fetch(url);
          const data = await response.json();
          return data.detected_values.country;
        } catch (error) {
          console.error('Error fetching user location:', error);
          return null;
        }
      }

      getLocationCookie(name) {
        const cookies = `; ${document.cookie}`;
        const parts = cookies.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
      }

      setLocationCookie(name, value, days) {
        const expiryDate = new Date();
        expiryDate.setTime(expiryDate.getTime() + days * 24 * 60 * 60 * 1000);
        const expires = `expires=${expiryDate.toUTCString()}`;
        document.cookie = `${name}=${value}; ${expires}; path=/`;
      }

      setupSuggestedCountry(userLocationName) {
        this.querySelectorAll('[data-suggested]').forEach((element) => {
          element.textContent = userLocationName;
        });
      }

      setupModalCloseButton() {
        const modalCloseButtons = this.querySelectorAll('[data-close]');
        if (modalCloseButtons.length > 0) {
          const closeListener = () => {
            this.setLocationCookie('country', this.shopLocation, 30);
            this.hide();
          };
          modalCloseButtons.forEach((button) => {
            button.addEventListener('click', closeListener);
            this.eventListeners.push({
              target: button,
              type: 'click',
              listener: closeListener,
            });
          });
        }
      }

      attachFormChangeListener(userLocation) {
        if (!this.form) return;
        const languageInput = this.form.querySelector('input[name="language_code"]');
        const countryInput = this.form.querySelector('input[name="country_code"]');

        if (!languageInput || !countryInput) return;

        const submitButton = this.form.querySelector('[data-submit]');
        const closeButton = this.form.querySelector('[data-close]');

        if (submitButton) {
          const submitClickListener = (event) => {
            event.preventDefault();

            try {
              const countries = this.countryList();

              if (!Array.isArray(countries)) {
                console.error('Countries is not an array:', countries);
                return;
              }

              const selectedCountry = countries.find((country) => country.country === userLocation.handle);

              if (!selectedCountry || !selectedCountry.languages || !selectedCountry.languages.length) {
                console.error('Invalid country data:', selectedCountry);
                return;
              }

              // Use the first language from the languages array
              languageInput.value = selectedCountry.languages[0].toLowerCase();
              countryInput.value = userLocation.handle;

              this.setLocationCookie('country', userLocation.handle, 30);

              fetch(this.form.action, {
                method: this.form.method,
                body: new FormData(this.form),
              })
                .then(() => {
                  const language = selectedCountry.languages[0].toLowerCase();
                  // Only append language to URL if it's not 'en'
                  const redirectUrl =
                    language === 'en' ? window.location.origin : `${window.location.origin}/${language}`;
                  window.location.href = redirectUrl;
                })
                .catch((error) => {
                  console.error('Error submitting form:', error);
                });
            } catch (error) {
              console.error('Error in submit handler:', error);
            }
          };

          submitButton.addEventListener('click', submitClickListener);
          this.eventListeners.push({
            target: submitButton,
            type: 'click',
            listener: submitClickListener,
          });
        }

        if (closeButton) {
          const closeClickListener = (event) => {
            event.preventDefault();
            this.setLocationCookie('country', this.shopLocation, 30);
            this.hide();
          };

          closeButton.addEventListener('click', closeClickListener);
          this.eventListeners.push({
            target: closeButton,
            type: 'click',
            listener: closeClickListener,
          });
        }
      }

      removeEventListeners() {
        this.eventListeners.forEach(({ target, type, listener }) => {
          target.removeEventListener(type, listener);
        });
        this.eventListeners = [];
      }
    }
  );
}
